export default {
    anchorTarget: '_blank',
    rel: 'noopener',
};
//# sourceMappingURL=linkSettings.js.map